import {RelationshipsModel} from "../../../models/responses/relationships.model";
import {useTypedSelector} from "../selectors.utils";

export const getRelationshipsForSpecificTask = (relationshipsList: RelationshipsModel[], taskId: string) => {
    return relationshipsList.filter(task => task.task_id === taskId);
};
export const useAllRelationshipsSelector = () => useTypedSelector<RelationshipsModel[]>(state => state.relationships.relationshipsList);
